export default "__VITE_ASSET__Bflz2AD6__"